import { BookOpenTextIcon, ClipboardCheckIcon, FolderOpenIcon, LightbulbIcon, UsersIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  note?: string;
  benefit?: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Banco de 150 Actividades y Desafíos sobre Energía Nuclear',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre fundamentos, radiactividad, fisión, reactores, seguridad, residuos, aplicaciones y sostenibilidad. Organizadas por nivel de dificultad.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Kit de Evaluación Docente sobre Energía Nuclear',
    description: 'Recursos completos para evaluar conocimientos y competencias:',
    items: [
      'Material para acompañar evaluación',
      'Preguntas de evaluación',
      'Consignas de análisis',
      'Ejercicios de desarrollo',
      'Situaciones problemáticas',
      'Casos de análisis',
      'Propuestas de evaluación',
      'Criterios de corrección',
      'Rúbricas',
      'Listas de cotejo',
      'Autoevaluaciones',
      'Coevaluaciones',
    ],
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Casos y Situaciones para Analizar sobre Energía Nuclear',
    description: '100 situaciones prácticas para desarrollar análisis, razonamiento y toma de decisiones sobre:',
    items: [
      'Fundamentos nucleares',
      'Radiactividad',
      'Fisión y energía',
      'Reactores',
      'Seguridad nuclear',
      'Residuos radiactivos',
      'Aplicaciones médicas',
      'Aplicaciones industriales',
      'Sostenibilidad',
      'Debates y decisiones',
      'Situaciones profesionales integradoras',
    ],
    benefit: 'Tus alumnos aprenden analizando situaciones reales de energía nuclear.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '04',
    title: '100 Proyectos, Debates y Propuestas para el Aula sobre Energía Nuclear',
    description: 'Incluye 100 propuestas para trabajar la energía nuclear desde múltiples dimensiones:',
    items: [
      'Proyectos de investigación',
      'Proyectos de simulación',
      'Proyectos de análisis',
      'Debates argumentados',
      'Propuestas de participación',
      'Discusiones fundamentadas',
      'Análisis de decisiones',
      'Evaluación de consecuencias',
      'Comparación de alternativas',
      'Pensamiento crítico',
    ],
    note: 'Cada propuesta incluye objetivos, procedimientos y recursos necesarios.',
    benefit: 'Tus alumnos salen con proyectos reales en sus portafolios.',
    value: 'USD 14',
    icon: UsersIcon,
  },
  {
    number: '05',
    title: 'Guía Docente de Conceptos, Glosario y Mitos sobre Energía Nuclear',
    description: 'Recurso de consulta para docentes con:',
    items: [
      'Conceptos esenciales',
      'Terminología nuclear',
      'Explicaciones claras',
      'Mitos y realidades',
      'Dudas frecuentes',
      'Confusiones habituales',
      'Clarificaciones científicas',
      'Contexto histórico',
      'Referencias y fuentes',
      'Respuestas a preguntas comunes',
    ],
    note: 'Incluye pasos de explicación, ejemplos prácticos y estrategias de enseñanza.',
    value: 'USD 14',
    icon: BookOpenTextIcon,
  },
];
